<template>
  <v-autocomplete
    hide-details="auto"
    :items="customers"
    :loading="loading"
    v-model="filterDatas.customer"
    item-text="name"
    item-value="id"
    label="Customer"
    clearable
    outlined
    dense
    @change="emitInput(filterDatas.customer)"
    :search-input.sync="searchCustomer"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

import { CustomerViewModel } from '../../models/View Models/CustomerViewModel';
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    customers: [],
    selectedCustomer: null,
    searchCustomer: null,
    loading: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', data);
      this.$emit('input', this.filterDatas.customer);
    },
    getCustomerByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('customer/GetCustomerSearch', {
          query: this.filterDatas.customerquery
            ? this.filterDatas.customerquery
            : query,

          status: 'active',
        })
        .then((res) => {
          this.loading = false;
          this.customers = res.map((u, i, arr) => {
            u.index = i + 1;
            return new CustomerViewModel(u);
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedCustomer = null;
      },
      deep: true,
    },
    searchCustomer: {
      handler(val) {
        this.$store.commit('UPDATE_CUSTOMER_QUERY_FILTER', val);
        this.getCustomerByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    this.getCustomerByQuery();
    this.$emit('input', this.filterDatas.customer);
  },
};
</script>
